<template>
  <el-dialog
      :visible="visible"
      :before-close="close"
      @opened="onOpen"
      width="560px"
  >

    <div slot="title">
      <div class="el-dialog__title">Продажа товара или услуги</div>
      <div class="el-dialog__subtitle">Пожалуйста, внимательно проверьте и заполните информацию о клиенте перед тем как
        продолжить работу
      </div>
    </div>

    <el-form ref="dataForm" class="data-form" :rules="rormRules" :model="dataForm" v-loading="loading">
      <el-form-item label="Клиент (опционально)" prop="user" :error="errors.user | errorToSrt">
        <el-input
            placeholder="Нажмите чтобы выбрать клиента"
            auto-complete="off"
            name="user"
            @change="checkUserPhone"
            v-model="dataForm.user"></el-input>
      </el-form-item>
      <template v-if="!findUsers.length">
        <el-form-item label="Товар или услуга" prop="position" :error="errors.position | errorToSrt">
          <el-input v-model="dataForm.position"
                    name="position"
                    prefix-icon="el-icon-search"
                    ref="autoFocus"
                    placeholder="Введите название товара..."
                    maxlength="255"/>
        </el-form-item>

        <div class="pay-method">

          <el-form-item style="flex: 1;" label="Метод оплаты" prop="payMethod" :error="errors.payMethod | errorToSrt">
            <el-select v-model="dataForm.payMethod" class="data-form__select" placeholder="Выберите">
              <el-option
                  label="Подарок"
                  value="1"/>
              <el-option
                  label="Рубли"
                  value="2"/>
            </el-select>
          </el-form-item>

          <el-form-item style="width: 140px;" label="Кол-во" prop="quantity" :error="errors.quantity | errorToSrt">
            <el-input-number style="width: 100%;" v-model="dataForm.quantity" @change="handleChange" :min="1"
                             :max="100"></el-input-number>
          </el-form-item>


          <el-form-item v-if="dataForm.payMethod == 2" style="width: 140px;" label="Итого"
                        :error="errors.quantity | errorToSrt">
            <el-input style="width: 100%;" v-model="dataForm.quantity" @change="handleChange" ></el-input>
          </el-form-item>


        </div>


      </template>
      <footer-buttons>
        <el-button
            type="primary"
            :loading="loadBtn"
            @click="saveForm"
        >Провести продажу
        </el-button>
        <el-button

            :loading="loadBtn"
            @click="close"
        >Отмена
        </el-button>
      </footer-buttons>

    </el-form>


  </el-dialog>
</template>

<script>
import moment from "moment"
import FooterButtons from "@/components/dialog/FooterButtons"

export default {
  name: "AddSail",
  data() {
    return {
      form: null,
      error: null,
      loading: false,
      loadBtn: false,
      findUsers: [],
      errors: {},
      dataForm: {},
      rormRules: {
        name: [
          {required: true, message: 'Укажите имя', trigger: 'blur'}
        ],
        quantity: [{required: true, message: 'Укажите кол-во', trigger: 'blur'}],
        phone: [{
          required: true,
          message: "Укажите номер",
          trigger: "blur"
        },
          {
            min: 16,
            max: 16,
            message: "Введите все цифры номера",
            trigger: "blur",
          },
        ],
        birthday: [
          {required: true, message: 'Укажите дату', trigger: 'blur'}
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          let date = moment().subtract(18, 'y').valueOf()
          return time.getTime() > date
        },
        defaultValue: moment().subtract(18, 'y').valueOf(),
      }
    }
  },
  props: {
    visible: {
      required: true,
    }
  },
  filters: {
    errorToSrt(t) {
      return t ? t.join(', ') : null
    }
  },
  computed: {},
  components: {

    FooterButtons
  },
  methods: {
    onOpen() {

    },

    close() {
      this.dataForm = {}
      this.findUsers = []
      this.$refs.dataForm.clearValidate()
      this.$emit('close')
    },
    checkUserPhone() {

      let payLoad = {...this.dataForm}

      let params = {
        params: {
          phone: payLoad.phone.replace(/[^\d]/g, '')
        },
      }

      this.$api.user.checkPhone(params)
          .then((response) => {
            this.findUsers = response.data

            if (response.data.length) {
              this.$notify.success({
                title: 'Нашелся пользователь',
                message: 'Найден пользователь с данным номером'
              })
            } else {
              this.$notify.success({
                title: 'Проверка пройдена',
                message: 'Пользователь с данным номером не найден'
              })
            }
          })
          .catch((response) => {
            this.$notify.error({
              title: 'Ошибка проверки номера',
              message: response.response.data.message
            })
          })
          .finally(() => {

          })

    },
    goUser(user) {
      this.$emit('created', user)
      this.close()
    },
    saveForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loadBtn = true

          let payLoad = {...this.dataForm}
          payLoad.phone = payLoad.phone.replace(/[^\d]/g, '')

          this.$api.user.create(payLoad)
              .then((response) => {
                this.$notify.success({
                  title: 'Успешно',
                  message: 'Новый пользователь создан'
                })

                this.goUser(response.data)
              })
              .catch((response) => {
                this.$notify.error({
                  title: 'Ошибка',
                  message: response.response.data.message
                })
              })
              .finally(() => {
                this.loadBtn = false
              })
        }
      })

    }


  }
};
</script>

<style scoped lang="scss">

.data-form {
  margin-top: 24px;

  &__select, &__date-picker {
    width: 100%;
  }

  &__btn {
    margin-bottom: 14px;
  }
}

.pay-method {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
</style>

